import { enableProdMode, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MncCHAPPModule as MncCHAPPModule } from '@app/mnc-chapp.module';
import { environment } from '@env/environment';

if (environment.production) {
  enableProdMode();
}

const { buildNumber, commit } = environment.version;

console.log('CHAPP UI Version:', {
  buildNumber,
  commit,
})

platformBrowserDynamic()
  .bootstrapModule(MncCHAPPModule, {
    providers: [
      { provide: LOCALE_ID, useValue: 'en-US' }
    ],
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => console.error(err));
